import { updateLinksAttributes } from '../utils/handleAttributes';
import { missingWidget } from '../utils/helpers';

export default function scrollerSponsors() {
  const widgetName = 'scrollerSponsors';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof scrollerSponsorsOpts === 'undefined' ? null : scrollerSponsorsOpts;

  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }

  const interval = setInterval(function () {
    if ($('body').hasClass('pageIsLoaded')) {
      setTimeout(() => {
        changeSponsorsStructure();
        $('.scrollerSponsors-wrapper').css('opacity', '1');
      }, 3000);

      const pauseBtn = $(`#${widgetName} .sponsor-controls-container button`);
      pauseBtn.replaceWith('<span class="sponsor-playpause-btn"></span>');
      $(`#${widgetName} .sponsor-playpause-btn`).on('click', function () {
        $(`#${widgetName} .sponsorWidgetContainer `).toggleClass('sponsors-paused');
      });

      $(`#${widgetName} .sponsor-controls-container`).on('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          $(`#${widgetName} .sponsorWidgetContainer`).toggleClass('sponsors-paused');
        }
      });
      clearInterval(interval);
    }
  }, 800);

  function changeSponsorsStructure() {
    const $majorSponsorTitle = $('#scrollerSponsors #majorSponsorTitleContainer');
    const $majorSponsorContainer = $('#scrollerSponsors .majorSponsor');
    const majorSponsorsTitle = $('#majorSponsorTitleContainer .homepageh1').text();

    if ($majorSponsorContainer.length && $majorSponsorTitle.length) {
      $majorSponsorTitle.wrapAll('<div class="major-sponsor-wrapper" id="major-sponsor-wrapper">');
      $majorSponsorContainer.appendTo($('#major-sponsor-wrapper'));
      $('#major-sponsor-wrapper').prependTo($('#scrollerSponsors'));

      $('#majorSponsorTitleContainer .homepageh1').replaceWith(
        `<h3 class="major-sponsor-title">${majorSponsorsTitle}</h3>`,
      );
    }

    const sponsorsTitleContent = $('#sponsorsTitleContainer .homepageh1').text();
    $('#sponsorsTitleContainer .homepageh1').replaceWith(
      `<h3 class="main-sponsors-title">${sponsorsTitleContent}</h3>`,
    );

    $('#scrollerSponsors').append('<div class="scroller-container">');

    $('#scrollerSponsors #sponsorArrowLeft').appendTo('.scroller-container');
    $('#scrollerSponsors .sponsorWidgetContainer ').appendTo('.scroller-container');
    $('#scrollerSponsors #sponsorArrowRight').appendTo('.scroller-container');
    $('#scrollerSponsors .sponsor-controls-container').appendTo('.sponsorWidgetContainer ');
    $('#scrollerSponsors .sponsor-controls-container')
      .attr('tabindex', '0')
      .prependTo('.scroller-container .sponsorWidgetContainer');

    $('.sponsorCarouselImageContainer a').each(function () {
      const $element = $(this);
      const href = $element.attr('href')?.trim();
      const altText = $element.find('img').attr('alt');
      const url = href?.startsWith('http') ? href : null;
      updateLinksAttributes(url, altText, $element);
    });
  }

  return saffire.widgets.sponsors($($widget), {
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    timePerSponsor: 6,
    bw: false,
    rotate: true,
  });
}
